import styled, { css } from "styled-components";
import {
  PAGE_SIDE_PADDING,
  PAGE_VERTICAL_PADDING
} from "../styling/constants";
import { CONTROL_FIELD_BORDER_COLOR, CONTROL_FIELD_HEIGHT } from "../styling/theme";

export const CardContainer = styled.div`
  background-color: white;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
  border-radius: 4px;
  border: 1px solid #d9d9d980;
  padding: 2rem;
`;

export const CardHeader = styled.h4`
  display: block;
  padding: 2rem 0px;
  margin-bottom: 20px;
  border-bottom: 1px solid #fafafa;
  color: #00425F;
  box-sizing: border-box;
`;

export const CardContent = styled.div`
  padding: 2rem;
  box-sizing: border-box;
`;

const HEADER_HEIGHT = 60;

export const PageView = styled.div`
  position: relative;
  width: 100%;
  padding: ${PAGE_VERTICAL_PADDING / 10}rem ${PAGE_SIDE_PADDING / 10}rem;
  padding-top: ${(PAGE_VERTICAL_PADDING + HEADER_HEIGHT + 20) / 10}rem;
  box-sizing: border-box;
`;

export const PageViewHeader = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: ${HEADER_HEIGHT / 10}rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  padding-left: ${PAGE_SIDE_PADDING}px;
  box-sizing: border-box;

  h3 {
    font-size: 1.8rem;
    color: #4B4B4B;
  }
`;

export const FormSectionDivider = styled.div`
  height: 1px;
  background-color: #ddd;
  margin: 20px 0px;
`;



// Form styles
export const FormControlContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
`;

export const FormControlLabel = styled.label`
  font-size: 1.3rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #4B4B4B;
`;

export const FormFieldStyles = css`
  display: block;
  width: 100%;
  height: ${CONTROL_FIELD_HEIGHT / 10}rem;
  padding: 0px 10px;
  font-size: 1.6rem;
  color: #495057;
  background-color: #fff;
  border: 1px solid ${CONTROL_FIELD_BORDER_COLOR};
  border-radius: 4px;
  box-sizing: border-box;
  outline: none;
`;

export const FieldErrorText = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 5px;
`;